import LoopDefinitionInput from '@dashboard/components/editor/EditorSidebar/BlockSidebarForm/inputs/special/LoopDefinitionInput';

import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';

const LoopContainerSidebarForm = createBlockInputSection({
  title: 'Loop block',
  inputs: [LoopDefinitionInput, 'backgroundColor', 'padding', HideSectionInput],
});

export default LoopContainerSidebarForm;
